import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
var AKDynamicTable = /*#__PURE__*/React.lazy(function () {
  return import('@atlaskit/dynamic-table').then(function (module) {
    return {
      default: module.DynamicTableStateless
    };
  });
});
export var Wrapper = /*#__PURE__*/function (_React$Component) {
  function Wrapper() {
    var _this;
    _classCallCheck(this, Wrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Wrapper, [].concat(args));
    _defineProperty(_this, "state", {
      retried: false
    });
    return _this;
  }
  _inherits(Wrapper, _React$Component);
  return _createClass(Wrapper, [{
    key: "componentDidCatch",
    value:
    /**
     * There's a bug with Suspense and findDOMNode https://github.com/facebook/react/issues/14188
     * We've opted to catch and ignore the error temporarily while we address the issue in Atlaskit
     * See http:/go/j/FUI-870
     */
    function componentDidCatch(error) {
      var _this2 = this;
      if (error && error.message && (error.message === 'Unable to find node on an unmounted component.' || error.message.startsWith('Minified React error #188;')) && !this.state.retried) {
        this.setState({
          retried: true
        }, function () {
          return _this2.setState({
            retried: false
          });
        });
      } else {
        throw error;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        Component = _this$props.Component,
        head = _this$props.head,
        isFixedSize = _this$props.isFixedSize,
        onSetPage = _this$props.onSetPage,
        page = _this$props.page,
        rows = _this$props.rows,
        rowsPerPage = _this$props.rowsPerPage;
      if (Component) {
        return /*#__PURE__*/React.createElement(Component, {
          head: head,
          isFixedSize: isFixedSize,
          onSetPage: onSetPage,
          page: page,
          rows: rows,
          rowsPerPage: rowsPerPage
        });
      } else {
        return null;
      }
    }
  }]);
}(React.Component);
var LazyLoadedTable = function LazyLoadedTable(props) {
  var head = props.head,
    isFixedSize = props.isFixedSize,
    onSetPage = props.onSetPage,
    page = props.page,
    rows = props.rows,
    rowsPerPage = props.rowsPerPage;
  return /*#__PURE__*/React.createElement(Wrapper, {
    Component: AKDynamicTable,
    head: head,
    isFixedSize: isFixedSize,
    onSetPage: onSetPage,
    page: page,
    rows: rows,
    rowsPerPage: rowsPerPage
  });
};
export default LazyLoadedTable;